module.exports = __webpack_public_path__ + "media/audio5.13d3150f.mp3";